import React, { useRef, useState } from 'react';

import { OriginalProductHint } from './original-product-hint';
import { OriginalProductModal } from './original-product-modal';
import { OriginalProductMarker } from './original-product-marker';
import { OriginalProductType } from 'features/page-model';
import { ReturnValueDeviceType } from 'entries/server/utils';

type OriginalProductProps = {
  info: OriginalProductType | null;
  deviceType: ReturnValueDeviceType;
};

export const DATA_QA_ORIGINAL_PRODUCT_HIDDEN = 'original-product-hidden';

export const OriginalProduct: React.FC<OriginalProductProps> = ({ info, deviceType }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const sharedText = {
    actionButton: info?.tooltip.buttonText || '',
    header: info?.tooltip.title || '',
    paragraph: info?.tooltip.text || '',
  };

  const marker = (
    <OriginalProductMarker color={info?.color || ''} text={info?.text || ''} onOpen={handleOpen} ref={ref} />
  );

  return (
    <>
      {deviceType === 'desktop' ? (
        <OriginalProductHint close={handleClose} open={open} anchor={marker} text={sharedText} />
      ) : (
        <>
          {marker}
          <OriginalProductModal
            mobile={deviceType === 'mobile'}
            open={open}
            onClose={handleClose}
            text={sharedText}
          />
        </>
      )}
      <div hidden data-qa={DATA_QA_ORIGINAL_PRODUCT_HIDDEN}>
        <p>{sharedText.header}</p>
        <p>{sharedText.paragraph}</p>
      </div>
    </>
  );
};
